import { nuiCtx } from '../../../common/initialization';

export interface PushCallbacks {
    onSnapshot: (snapshot: any) => void;
    onMessage: (message: any) => void;
}

export interface PushSubscription {
    count: number;
    subscription: any;
}
const activePushSubscriptions: Map<string, PushSubscription> = new Map();

export function subscribePath(path: string, { onSnapshot, onMessage }: PushCallbacks, force?: boolean) {
    const existingSubscription = activePushSubscriptions.get(path);
    if (existingSubscription && !force) {
        existingSubscription.count++;
        return;
    }

    const subscription = nuiCtx.pushClient.subscription({
        onSnapshot: data => onSnapshot(data[0]),
        onMessage
    });
    subscription.resetPaths([path]);
    activePushSubscriptions.set(path, {
        subscription,
        count: 1
    });
}

export function unsubscribePath(path: string) {
    const existingSubscription = activePushSubscriptions.get(path);
    if (!existingSubscription) {
        return;
    }
    if (existingSubscription.count-- === 1) {
        existingSubscription.subscription.close();
        activePushSubscriptions.delete(path);
    }
}
